import { render } from "./role-header.vue?vue&type=template&id=6cc1fb07"
import script from "./role-header.vue?vue&type=script&lang=js"
export * from "./role-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__